import React, { useState, useEffect } from "react";
import { Grommet, Box, ResponsiveContext } from 'grommet';
import { hpe } from 'grommet-theme-hpe';
import { Header, Notification, AgentSidebar, PageFooter, ContentDisplay } from './components';
import { Home } from './pages/home';
import { RoadmapsHome, RoadmapSummary, RoadmapDisplay } from './pages/roadmaps';
import { HoHHome } from './pages/hoh';
import { AIHome } from './pages/ai-internal';
import { BlogHome } from './pages/blog';
import { InnovationHome } from './pages/innovation';
import { StandardsHome } from './pages/standards';
import { PlatformsHome } from './pages/platforms';
import { UserJourneySummaryView } from './pages/userJourneys'
import { ValueStreamsHome } from './pages/valuestreams';
import { ProductLedHome } from './pages/productled';
import { LeadToCashSystems } from './pages/roadmaps/systems';
import { EAHome } from './pages/ea';
import { TCPHome } from './pages/tcp';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HeaderHeightProvider } from './utils/HeaderHeightContext';


function App() {

    // State to track if the agent dialog is expanded or collapsed
  const [isAgentExpanded, setIsAgentExpanded] = useState(false);

  // Toggle function to expand/collapse the agent
  const toggleAgent = () => {
    setIsAgentExpanded((prev) => !prev);
  };

  // WalkMe injection...
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;

    const walkmeScriptUrl =
      process.env.REACT_APP_ENV === 'production'
        ? 'https://cdn.walkme.com/users/0841eebe50604434869dd9afe567ce5f/walkme_0841eebe50604434869dd9afe567ce5f_https.js'
        : 'https://cdn.walkme.com/users/0841eebe50604434869dd9afe567ce5f/test/walkme_0841eebe50604434869dd9afe567ce5f_https.js';

    script.src = walkmeScriptUrl;

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script); // Cleanup if needed
    };
  }, []);  
  
  return (
    <HeaderHeightProvider> 
      <BrowserRouter>
        <Grommet className="App" theme={hpe} full>
          <ResponsiveContext.Consumer>
            {size => (
              <Box fill background="background" direction="column" style={{ height: '100vh' }}>

                {/* Header */}
                <Box width="100%" elevation="medium" flex={false}>
                  <Header toggleAgent={toggleAgent} />
                </Box>

                {/* Main Content */}
                <Box flex="grow" overflow="auto">
                  <Notification />
                  <Box margin={{ top: 'xxsmall' }} direction="row" flex="grow" >
                    <Box flex={true} overflow="auto">
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/roadmaps" element={<RoadmapsHome />} />
                        <Route path="/roadmap-display" element={<RoadmapDisplay />} />
                        <Route path="/roadmap-summary" element={<RoadmapSummary />} />
                        <Route path="/hoh/:tabId?" element={<HoHHome />} />
                        <Route path="/ai" element={<AIHome />} />
                        <Route path="/innovation" element={<InnovationHome />} />
                        <Route path="/standards" element={<StandardsHome />} />
                        <Route path="/platforms" element={<PlatformsHome />} />
                        <Route path="/ea" element={<EAHome />} />
                        <Route path="/blog" element={<BlogHome />} />
                        <Route path="/valuestreams" element={<ValueStreamsHome />} />
                        <Route path="/productled" element={<ProductLedHome />} />
                        <Route path="/systems/lead-to-cash" element={<LeadToCashSystems />} />
                        <Route path="/user-journeys" element={<UserJourneySummaryView />} />
                        <Route path="/tcp" element={<TCPHome />} />
                        <Route path="/content-display" element={<ContentDisplay />} />
                        <Route path="*" element={<Home />} />
                      </Routes>  
                    </Box>
                    <AgentSidebar isAgentExpanded={isAgentExpanded} />
                  </Box>
                </Box>

                {/* Footer */}
                <Box width="100%" flex={false}>
                  <PageFooter />
                </Box>

              </Box>
            )}
          </ResponsiveContext.Consumer>
        </Grommet>
      </BrowserRouter>
    </HeaderHeightProvider>
  );
}

export default App;
